import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { Box, FormControl, FormLabel, TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { date, string } from 'yup'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

import { DEFAULT_DATE_FORMAT } from 'lib/participants/Constants'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { setAnswer } from 'redux/slices/SignupFormAnswers'
import { getErrorHelperText } from 'lib/participantProfile/Helper'
import i18n from 'i18n'

export const validateDateQuestion = async (
  answer: { value: string },
  question: QuestionsItems,
): Promise<string[]> => {
  let schema = isEmpty(answer?.value) ? string().nullable() : date().nullable()

  if (question.required) {
    schema = schema.required(
      i18n.t('errors.blank', { question: question.question }),
    )
  }

  schema = schema.typeError(i18n.t('errors.invalidDateError'))

  try {
    await schema.validate(answer?.value)
    return []
  } catch (err: any) {
    return err.errors
  }
}

const DateQuestion = ({
  question,
  id,
  readOnlyMode,
  required,
}: {
  question: string
  id: string
  readOnlyMode: boolean
  required: boolean
}) => {
  const { answers, errors } = useAppSelector((state) => state.signupAnswers)
  const mappedDateAnswer = answers[id]?.value
  const error = errors[id] || []
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const answer = mappedDateAnswer ? new Date(mappedDateAnswer) : null

  const handleDateChange = (newValue: Date | null) => {
    dispatch(
      setAnswer({
        questionId: id,
        answer: { value: moment(newValue).format('YYYY-MM-DD') },
      }),
    )
  }

  return (
    <Box id={id}>
      <FormControl error={error.length > 0} fullWidth required={required}>
        <FormLabel> {question} </FormLabel>
        <LocalizationProvider
          dateAdapter={AdapterMoment}
          localeText={{
            nextMonth: t('datePicker.nextMonth'),
            previousMonth: t('datePicker.previousMonth'),
          }}
        >
          <DesktopDatePicker
            views={['day']}
            value={answer}
            inputFormat={DEFAULT_DATE_FORMAT}
            readOnly={readOnlyMode}
            onChange={(newValue) => handleDateChange(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                variant="standard"
                error={error.length > 0}
                helperText={getErrorHelperText(error, question)}
              />
            )}
          />
        </LocalizationProvider>
      </FormControl>
    </Box>
  )
}

export default DateQuestion
